import script from "./AlertsRulesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsRulesTab.vue?vue&type=script&setup=true&lang=js"

import "./AlertsRulesTab.vue?vue&type=style&index=0&id=f206d55c&lang=scss"

const __exports__ = script;

export default __exports__